import React from 'react';
import { Panel, Button } from 'react-bootstrap';

import Loading from '../components/Loading';
import FieldGroup from '../components/FieldGroup';
import AuthLib from '../lib/Auth';
import { handleHttpResponse } from '../lib/Helpers';
import LoggedInUser from '../lib/LoggedInUser';



const styles = {}
styles.page = {
  width: '100vw',
  height: '100vh',
  display: 'flex'
}
styles.panel_container = {
  margin: 'auto',
  minWidth: '300px'
}

class Auth extends React.Component {
  state = {
    email: '',
    password: '',
    loading: false
  }

  handleChange(e){
    const newState = {}
    newState[e.target.name] = e.target.value
    this.setState(newState);
  }

  handleSubmit(e) {
    e.preventDefault();
    const self = this
    const re = /@swipecast.com$/
    if (re.test(this.state.email)){
      this.setState({loading: true});

      const login = AuthLib.logIn(this.state.email, this.state.password);
      login.then(function(response){
        return handleHttpResponse(response)
        .then(function(result){
          LoggedInUser.setInfo(result);
          self.props.history.push('/');
        }).catch(function(err){
          console.log(err);
          self.setState({loading: false});
        })
      }).catch(function(err){
        console.log("There was an error, please try again");
        self.setState({loading: false});
        //**TODO: send response over to SC engineers
      })
    }
  }

  getButton(){
    if (this.state.loading) {
      return <Loading />
    } else {
      return (
        <Button type="submit">
          Submit
        </Button>
      );
    }
  }

  render(){
    let button = this.getButton();

    return(
      <div style={{...styles.page}}>
        <div style={{...styles.panel_container}}>
            <Panel header={"Log In"}>
              <form onSubmit={this.handleSubmit.bind(this)}>
                <FieldGroup
                  id="formControlsEmail"
                  type="email"
                  label="Email address"
                  placeholder="Enter email"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleChange.bind(this)}
                />
                <FieldGroup
                  id="formControlsPassword"
                  type="password"
                  label="Password"
                  placeholder="Password"
                  name="password"
                  value={this.state.password}
                  onChange={this.handleChange.bind(this)}
                />
                <div style={{textAlign: 'center'}}>
                  {button}
                </div>
              </form>
            </Panel>
        </div>
      </div>
    )
  }
}

export default Auth;
